<template>
	<v-dialog v-model="filterDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{ storeListVisible ? t('storeSearch') : t('filtering') }}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" 
						@click="filterDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-col class="ma-0 pa-0" cols="12">
					<v-col id="brand_box" class="ma-0 pa-0" cols="12" 
						v-if="brandBoxVisible == true">
						<v-row class="ma-0 pa-0" align="center" justify="start">
							<template v-if="brandLoading == false">
								<v-item-group class="ma-0 pa-0" dense v-model="selectedBrands" dark
									hide-details :column="false" multiple>
									<v-row class="ma-0 pa-0" align="center">
										<v-col class="ma-0 pa-0 ml-1 mr-1 mb-1" cols="auto" 
											v-for="(item, index) in brandList" :key="index">
											<v-item :value="item" v-slot="{ active, toggle }">
												<v-col class="ma-0 pa-2 grey_item" cols="auto" @click="toggle"
													:class="{'selected_item':active}">
													<v-row class="ma-0 pa-0" align="center">
														<template v-if="active">
															<input id="check_box" type="checkbox" :checked="active" />
														</template>
														<template v-else>
															<input id="check_box" type="checkbox" :checked="active" />
														</template>
														<v-col class="ma-0 pa-0 ml-2" cols="auto">
															{{item.brandName + ' (' + item.count + ')'}}
														</v-col> 
													</v-row>
												</v-col>
											</v-item>  
										</v-col>
									</v-row>       
								</v-item-group>
							</template>
							<template v-else>
								<v-col class="ma-0 pa-0 ml-5" cols="auto">
									<v-progress-circular indeterminate color="white"
										:width="4" :size="30"></v-progress-circular>
								</v-col>
							</template>
						</v-row>
					</v-col>
					<v-row class="ma-0 pa-0 dialog_text" align="center" 
						v-if="storeDataVisible && uacSupport">
            {{t('theConditions')}}:
						<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
							v-if="selectedBrands.length != 0 || !brandBoxVisible"
							id="back_clean_btn" elevation="0" @click="filterOpen = !filterOpen">
							<v-row class="ma-0 pa-0" align="center" style="color:white;"
								v-if="filterOpen == false">
								<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
									src="@/assets/images/plus_white.png"></v-img>
                  {{t('filtering')}}
							</v-row>
              <v-row class="ma-0 pa-0" align="center" style="color:white;" v-else>
								<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2" 
									id="rotate_icon" src="@/assets/images/plus_white.png"></v-img>
                  {{t('filtering')}}
							</v-row>
						</v-btn>
          </v-row>
          <v-row class="ma-0 pa-0 pt-4 pb-7" justify="center">
				    <v-col class="ma-0 pa-0" cols="12" align="left" id="store_list">
							<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12" v-if="filterOpen == false">
								<template v-if="areaLoading == false">
									<v-col class="ma-0 pa-0" cols="12" id="noneBorderBox">
										<v-treeview selected-color="blue"
											selectable dark dense return-object v-model="selectedStores"
											:items="storeList">
											<template v-slot:label="{item}">
												<v-col class="ma-0 pa-0" cols="auto">
													{{item.id}}
												</v-col>
											</template>
										</v-treeview>
									</v-col>
								</template>
								<template v-else>
									<v-row class="ma-0 pa-0 pb-2" justify="start">
										<v-col class="ma-0 pa-0" cols="12">
											<v-skeleton-loader
												:boilerplate="false" elevation="0" dark 
												type="list-item-three-line, list-item-two-line, list-item-three-line"
											></v-skeleton-loader>
										</v-col>
									</v-row>
								</template>
							</v-col>
              <v-col class="ma-0 pa-0" cols="12" v-else>
				      	<v-row class="ma-0 pa-0">
				      		<v-col class="ma-0 pa-2 pr-4" cols="2" align="right"
				      			style="border-right: 3px solid #4A4A4A;">
                    {{t('cctvCamera')}}
									</v-col>
				      		<v-col class="ma-0 pa-0" cols="10">
				      			<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" v-model="filterOptions.motion" />
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('motionDetect')}}</v-col>
												</v-row>
                      </v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-row class="ma-0 pa-0" align="center" justify="space-between">
													<v-col class="ma-0 pa-0" cols="5.5">
														<CustomDatePicker :viewTextField="true" :reset="resetValue"
															:initDate="true" :filteredData="motionDetectBeginDate" :disableFuture="true"
															@resultDate="motionDetectBeginDateFunc" />
													</v-col>
													<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
													<v-col class="ma-0 pa-0" cols="5.5">
														<CustomDatePicker :viewTextField="true" :reset="resetValue"
                              :filteredData="motionDetectEndingDate" :disableFuture="true"
															@resultDate="motionDetectEndingDateFunc" />
													</v-col>
				      					</v-row>
				      				</v-col>
				      			</v-row>
				      			<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" v-model="filterOptions.sound"/>
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('soundDetect')}}</v-col>
												</v-row>
                      </v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-row class="ma-0 pa-0" align="center" justify="space-between">
													<v-col class="ma-0 pa-0" cols="5.5">
														<CustomDatePicker :viewTextField="true" :reset="resetValue"
															:initDate="true" :filteredData="soundDetectBeginDate" :disableFuture="true"
															@resultDate="soundDetectBeginDateFunc" />
													</v-col>
													<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
													<v-col class="ma-0 pa-0" cols="5.5">
														<CustomDatePicker :viewTextField="true" :reset="resetValue"
                              :filteredData="soundDetectEndingDate" :disableFuture="true"
															@resultDate="soundDetectEndingDateFunc" />
													</v-col>
				      					</v-row>
				      				</v-col>
				      			</v-row>
				      			<!-- <v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" />
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('peopleDetect')}}</v-col>
												</v-row>
                      </v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-btn width="10rem" height="auto" class="ma-0 pa-2" 
				      						id="grey_btn" elevation="0">
				      						{{t('peopleDetect')}}
				      					</v-btn>
				      				</v-col>
				      			</v-row> -->
				      		</v-col>
				      	</v-row>
				      	<!-- <v-row class="ma-0 pa-0 mt-5">
				      		<v-col class="ma-0 pa-2 pr-4" cols="2"  align="right"
				      			style="border-right: 3px solid #4A4A4A;">{{t('analyze')}}</v-col>
				      		<v-col class="ma-0 pa-0" cols="10">
				      			<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0 pl-6" cols="4">{{t('selectDuration')}}</v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-row class="ma-0 pa-0" align="center" justify="space-between">
													<v-col class="ma-0 pa-0" cols="5.5">
														<CustomDatePicker :viewTextField="true" :time="false"
															@resultDate="beginDateFunc" />
													</v-col>
													<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
													<v-col class="ma-0 pa-0" cols="5.5">
														<CustomDatePicker :viewTextField="true" :time="false"
															@resultDate="endingDateFunc" />
													</v-col>
				      					</v-row>
				      				</v-col>
				      			</v-row>
										<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0 pl-6" cols="4">{{''}}</v-col>
											<v-col class="ma-0 pa-0" cols="8">
												<v-radio-group v-model="selectedAnylizeRadio"
													class="ma-0 pa-0" dense hide-details>
													<template v-for="item in anylizeRadioGroup">
														<v-radio :value="item.value" :key="item.value" dark
															color="#1976d2">
															<template v-slot:label>
																<v-col class="ma-0 pa-0 pt-2 pb-2" cols="auto"
																	style="color:white;font-size:0.9rem;">
																	{{item.label}}
																</v-col>
															</template>
														</v-radio>
													</template>
												</v-radio-group>
											</v-col>
										</v-row>
				      			<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" />
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('visitorCount')}}</v-col>
												</v-row>
                      </v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-row class="ma-0 pa-0" align="center">
				      						<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
				      							<v-select background-color="#272727" dark
															v-model="selectedVisitantStartOption"
				      								:items="visitantStartOptionList" dense hide-details outlined 
				      								item-text="label" item-value="value"
				      							></v-select>
				      						</v-col>
				      						<v-col class="ma-0 pa-0 pl-3 pr-3" cols="auto">~</v-col>
				      						<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
				      							<v-select background-color="#272727" dark
															v-model="selectedVisitantEndOption"
				      								:items="visitantEndOptionList" dense hide-details outlined 
				      								item-text="label" item-value="value"
				      							></v-select>
				      						</v-col>
				      					</v-row>
				      				</v-col>
				      			</v-row>
				      			<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" />
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('genderRatio')}}</v-col>
												</v-row>
                      </v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-row class="ma-0 pa-0" align="center">
													<v-col class="ma-0 pa-0" cols="2">{{t('man') + ' : ' + manPercent/10 }}</v-col>
                          <v-col class="ma-0 pa-0 pl-1 pr-1" cols="7" align-self="center">
                            <v-slider class="slider_slot" step="10" v-model="manPercent"
                              dense hide-details dark></v-slider>
                          </v-col>
													<v-col class="ma-0 pa-0" cols="2">{{t('weman') + ' : ' + womanPercent}}</v-col>
				      					</v-row>
				      				</v-col>
				      			</v-row>
				      			<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
				      				<v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" />
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('repeaterRatio')}}</v-col>
												</v-row>
                      </v-col>
				      				<v-col class="ma-0 pa-0" cols="8">
				      					<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
				      						<v-select background-color="#272727" dark
														v-model="selectedReVisitantOption"
				      							:items="reVisitantOptionList" dense hide-details outlined 
				      							item-text="label" item-value="value"
				      						></v-select>
				      					</v-col>
				      				</v-col>
				      			</v-row>
                    <v-row class="ma-0 pa-2 pt-0 pl-4 pb-3" align="center">
                      <v-col class="ma-0 pa-0" cols="4">
												<v-row class="ma-0 pa-0" align="center">
													<input id="check_box" type="checkbox" />
													<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('sales')}}</v-col>
												</v-row>
                      </v-col>
                      <v-col class="ma-0 pa-0" cols="8">
                        <v-row class="ma-0 pa-0" align="center">
				      						<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
				      							<v-select background-color="#272727" dark
															v-model="selectedSalesStartOption"
				      								:items="salesStartOptionList" dense hide-details outlined 
				      								item-text="label" item-value="value"
				      							></v-select>
				      						</v-col>
				      						<v-col class="ma-0 pa-0 pl-3 pr-3" cols="auto">~</v-col>
				      						<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
				      							<v-select background-color="#272727" dark
															v-model="selectedSalesEndOption"
				      								:items="salesEndOptionList" dense hide-details outlined 
				      								item-text="label" item-value="value"
				      							></v-select>
				      						</v-col>
				      					</v-row>
                      </v-col>
                    </v-row>
				      		</v-col>
				      	</v-row> -->
				      </v-col>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
						<v-btn class="ma-0 pa-0" id="grey_btn" @click="resetData"
					 		width="8rem" height="2rem">{{t('reset')}}</v-btn>
           	<v-btn class="ma-0 pa-0 ml-2" id="grey_btn" @click="filterDialogVisible = false"
					 		width="8rem" height="2rem">{{t('cancel')}}</v-btn>
           	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn"
					 		width="8rem" height="2rem" @click="editStores">{{t('confirm')}}</v-btn>
          </v-row>
        </v-col>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
import CustomDatePicker from '@/components/DatePicker.vue';
import { VISTANT_START_OPTION, VISITANT_END_OPTION, REVISITANT_OPTION,
	SALES_START_OPTION, SALES_END_OPTION } from '@/constants';
import {
	getBrandListCached,
	getAllStoresCached,
	fetchFilteredStores,
	filterStoresBySelectedBrands,
} from '@/api/storeSearchCache';
export default {
	props: {
		dialogVisible: Boolean,
		storeDataVisible: Boolean,
    brandBoxVisible: Boolean,
    filterVisible: Boolean,
    filterData: Object,
	},
	components: {
		customDialog, CustomDatePicker
	},
	mixins: [mixin.common],
	data: () => ({
		filterDialogVisible: false,
		userConfig: {},
		brandLoading: false,
		areaLoading: false,
		brandList: [],
		selectedBrands: [],
		// brandTotal: 0,
		selectedStores: [],
    filterOpen: true,
		storeListVisible: false,
		filterOptions: {
			motion: false,
			sound: false,
		},
		motionDetectBeginDate: '',
		motionDetectEndingDate: '',
		soundDetectBeginDate: '',
		soundDetectEndingDate: '',
		beginDate: '',
		endingDate: '',
		manPercent: 0,
		womanPercent: 0,
		visitantStartOptionList: VISTANT_START_OPTION,
		selectedVisitantStartOption: '10人',
		visitantEndOptionList: VISITANT_END_OPTION,
		selectedVisitantEndOption: '100人',
		reVisitantOptionList: REVISITANT_OPTION,
		selectedReVisitantOption: '50',
    salesStartOptionList: SALES_START_OPTION,
		selectedSalesStartOption: '100,000',
		salesEndOptionList: SALES_END_OPTION,
		selectedSalesEndOption: '500,000',
		selectedStoreList: [],
		setStoreListParams: [],
		storeList: [],
		selectedAnylizeRadio: 0,
    resetValue: '',
		currentRoutePath: '',
		uacSupport: true,
	}),
	computed: {
		anylizeRadioGroup() {
			return [
				{ label: this.$i18n.t('lang.common.requirementsOnAllDates'), value: 0 },
				{ label: this.$i18n.t('lang.common.conditionsEvenForOneDay'), value: 1 },
				{ label: this.$i18n.t('lang.common.conditionsInTotalValue'), value: 2 },
			];
		}
	},
	watch: {
		manPercent: function(item) {
			this.womanPercent = 10 - item/10;
		},
		dialogVisible: function(item) {
			this.filterDialogVisible = item;
      if(this.filterDialogVisible == true && this.filterVisible == true) {
        this.filterOpen = true;
      }
			if(item) {
				this.selectedBrands = [];
				this.selectedStores = [];
				this.currentRoutePath = this.$route.path;
				this.userConfig = this.$store.getters.getUserConfig;
			}

      //알림설정 필터링 treeview
      if(this.filterVisible == false && this.filterOpen == false && this.brandBoxVisible == false) {
				this.getAreaStores('','','','');
      }
		},
		filterDialogVisible: function(item) {
      if(item == true && this.filterData != undefined) { //필터링 데이터가 있는 경우 체크박스 표시
        if(this.filterData.motionBeginDate != '') {
          this.filterOptions.motion = true;
          this.motionDetectBeginDateFunc(this.filterData.motionBeginDate);
          this.motionDetectEndingDateFunc(this.filterData.motionEndingDate);
        }
        if(this.filterData.soundBeginDate != '') {
          this.filterOptions.sound = true;
          this.soundDetectBeginDateFunc(this.filterData.soundBeginDate);
          this.soundDetectEndingDateFunc(this.filterData.soundEndingDate);
        }
      }
			this.$emit('visible', item);
		},
		selectedBrands: function(item) {
			console.log('%cselectedBrands\n', "color:#008DD0;", item);
			if(item.length != 0) {
				this.getAreaStores('','','','');
        // this.brandTotal = item.count;
				// this.brandTotal = 0;
				// item.forEach((item) => {
				// 	this.brandTotal = this.brandTotal + item.count;
				// });
			} else {
				this.storeList = [];
			}
		},
		selectedStores: function(item) {
			let storeArray = [];
			item.forEach((store) => {
				storeArray.push(store.value[0])
			})
			let cameraStatusData = this.$store.getters.getCameraStatusData;
			// const arraySet = item.filter((area, idx, arr) => {
			// 	return arr.findIndex((item) => item.unisCustomerCd === area.unisCustomerCd) === idx
			// });
			console.log('%cselectedStores\n', "color:#008DD0;", storeArray);
			this.selectedStoreList = storeArray;
			if(this.currentRoutePath == '/camera-status') {
				// 카메라 상태 페이지에서
				this.setStoreListParams = storeArray.map(element => {
					let getIndex = cameraStatusData.findIndex(r => r.unisCustomerCd === element.unisCustomerCd);
					return {
						customerName: element.customerName,
						unisCustomerCd: element.unisCustomerCd,
						cameras: getIndex == -1 ? [] : cameraStatusData[getIndex].cameras
					}
				});
			} else {
				this.setStoreListParams = storeArray.map(element => {
					return {
						areaCd: element.areaCd,
						customerName: element.customerName,
						unisCustomerCd: element.unisCustomerCd
					}
				});
			}
		},
		'filterOptions': {
			deep: true,
			handler(val, oldVal) {
				this.filterRequest();
				this.selectedStores = [];
			}
		},
		motionDetectBeginDate: function() {
			this.filterRequest();
			this.selectedStores = [];
		},
		motionDetectEndingDate: function() {
			this.filterRequest();
			this.selectedStores = [];
		},
		soundDetectBeginDate: function() {
			this.filterRequest();
			this.selectedStores = [];
		},
		soundDetectEndingDate: function() {
			this.filterRequest();
			this.selectedStores = [];
		},
	},
	created() {
		this.storeListVisible = this.storeDataVisible;
		if(this.storeDataVisible) {
			this.filterOpen = false;
		}
		this.uacSupport = this.$store.getters.getUacSupport;
	},
	mounted(){
		this.getBrandData();
	},
	methods: {
		async getBrandData() {
			this.brandLoading = true;
			try {
				this.brandList = await getBrandListCached();
				console.log('%cBrand Data (cached)\n', "color:#008DD0;", this.brandList.length);
			} catch (e) {
				console.error('getBrandData failed', e);
			} finally {
				this.brandLoading = false;
			}
		},
		makeBrandCd() {
			if(this.selectedBrands.length == 0) return '';
			return new Promise((resolve, reject) => {
				let brandCd = '';
				// brandCd = this.selectedBrands.brandCd;
				this.selectedBrands.forEach((item, index) => {
					if(index == 0) brandCd = item.brandCd;
					else brandCd = brandCd + ',' + item.brandCd;
				});
				resolve(brandCd);
			});
		},
		async getAreaStores(motionBeginDate, motionEndingDate, soundBeginDate, soundEndingDate) {
			this.areaLoading = true;
			this.storeList = [];
			try {
				if (!this.selectedBrands || this.selectedBrands.length === 0) return;
				const hasFilter = !!(motionBeginDate || motionEndingDate || soundBeginDate || soundEndingDate);
				// motion/sound 조건이 있으면 서버에서 다시 가져오고(ephemeral), 없으면 캐시 활용.
				const baseStores = hasFilter
					? await fetchFilteredStores({
						motionBeginDate, motionEndingDate, soundBeginDate, soundEndingDate,
					})
					: await getAllStoresCached();
				const stores = filterStoresBySelectedBrands(baseStores, this.selectedBrands);
				console.log('%cArea Stores (cached)\n', "color:#008DD0;", stores.length, { hasFilter });

				if (this.userConfig.printCityName) { // 시구정촌 표시 여부
					const group1 = this.groupBy(stores, data => data.unisCustomerPref);
					group1.forEach((item, index) => {
						const group2 = this.groupBy(item.value, data => data.areaName);
						group1[index].children = group2;
						group2.forEach((g2item, index2) => {
							const group3 = this.groupBy(g2item.value, data => data.unisCustomerName);
							group2[index2].children = group3;
						});
					});
					this.storeList = group1;
				} else {
					const group1 = this.groupBy(stores, data => data.unisCustomerPref);
					group1.forEach((item, index) => {
						const group2 = this.groupBy(item.value, data => data.unisCustomerName);
						group1[index].children = group2;
					});
					this.storeList = group1;
				}
			} catch (e) {
				console.error('getAreaStores failed', e);
			} finally {
				this.areaLoading = false;
			}
    },
		groupByChildren(list, keyGetter) {
			const map = new Map();
			list.forEach((item) => {
				const key = keyGetter(item);
				const collection = map.get(key);
				if (!collection) {
					map.set(key, [item]);
				} else {
					collection.push(item);
				}
			});
			return Array.from(map, ([id, value]) => ({ id, children: value }));
		},
		resetData() {
      this.filterOptions.motion = false;
      this.filterOptions.sound = false;
      this.resetValue = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString();
      this.selectedBrands = [];
      this.selectedStores = [];
		},
		editStores() {
			if(this.brandBoxVisible == false) {
				if(this.storeDataVisible && this.selectedStores.length == 0 && !this.filterOpen) {
					this.showToastMessage('選択した店舗がありません。');
					return;
				}
				if(this.storeDataVisible && this.selectedStores.length == 0 && this.filterOpen) {
					this.filterOpen = false;
					return;
				}
				this.filterEmit();
				this.$emit('edit', this.setStoreListParams);
				console.log('=================, ', this.setStoreListParams)
				this.filterDialogVisible = false;
			} else {
				if(this.filterOpen) {
					this.filterOpen = false;
				} else {
					if(this.selectedStores.length == 0) {
						this.showToastMessage('選択した店舗がありません。');
						return;
					}
					this.$emit('edit', this.setStoreListParams);
					console.log('=================', this.setStoreListParams);
					this.filterOpen = false;
					this.filterDialogVisible = false;
				}
			}
		},
		filterRequest() {
			let motionBegin = '';
			let motionEnd = '';
			let soundBegin = '';
			let soundEnd = '';
			if(this.filterOptions.motion) {
				motionBegin = this.motionDetectBeginDate;
				motionEnd = this.motionDetectEndingDate;
			}
			if(this.filterOptions.sound) {
				soundBegin = this.soundDetectBeginDate;
				soundEnd = this.soundDetectEndingDate;
			}
			this.getAreaStores(motionBegin, motionEnd, soundBegin, soundEnd);
		},
		filterEmit() {
			let params = {
				motionBeginDate: '',
				motionEndingDate: '',
				soundBeginDate: '',
				soundEndingDate: '',
			}
			if(this.filterOptions.motion == true) {
				params.motionBeginDate = this.motionDetectBeginDate;
				params.motionEndingDate = this.motionDetectEndingDate;
			}
			if(this.filterOptions.sound == true) {
				params.soundBeginDate = this.soundDetectBeginDate;
				params.soundEndingDate = this.soundDetectEndingDate;
			}
			this.$emit('filterParams', params);
		},
		motionDetectBeginDateFunc(date) {
			this.motionDetectBeginDate = date;
		},
		motionDetectEndingDateFunc(date) {
			this.motionDetectEndingDate = date;
		},
		soundDetectBeginDateFunc(date) {
			this.soundDetectBeginDate = date;
		},
		soundDetectEndingDateFunc(date) {
			this.soundDetectEndingDate = date;
		},
		// ANCHOR
		beginDateFunc(date) {
			console.log('beginDateFunc ========== ', date)
			this.beginDate = date;
		},
		endingDateFunc(date) {
			this.endingDate = date;
			console.log('endingDateFunc ========== ', date)
		},
	}
}
</script>

<style lang="scss" scoped>
.grey_item {
	cursor: pointer;
	border: 1px solid #6A6A6A;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
}
.selected_item {
	cursor: pointer;
	background-color: #4E4E4E;
	border-radius: 4px;
	color: white;
	min-width: 1rem;
	border: 1px solid #6A6A6A;
}
#brand_box {
	max-height: 100px;
  overflow: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
	.v-treeview--dense .v-treeview-node__root {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node .v-treeview-node--leaf {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__checkbox { // 트리뷰 체크박스 CSS
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}

	// Select box v화살표 위치
	.v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}

	// v-skeleton-loader css 설정
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
		background: #171921 !important;
	}
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
		background: #171921 !important;
	}
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#rotate_icon{
  transform: rotate(45deg);
}
#noneBorderBox {
	min-height: 350px;
	max-height: 350px;
  overflow: auto;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#store_list {
	overflow: auto;
	min-height: 350px;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#picker_bottom_menu {
	background-color: #272727;
  border: 1px solid #4A4A4A;
  color: white;
  justify-content: start;
}
</style>